import React from 'react'
import { Pages } from './routes/routesState'
import { CurrentPage } from '../utils/routes'

export const RootLayout = (props: {
  children: React.ReactNode
  kind: CurrentPage<Pages>['kind']
  extraClasses: string
}) => (
  <main id="a11y-main" className={`main main--${props.kind} ${props.extraClasses}`}>
    <div className="main__inner">
      <article className="page">
        <div className="page__inner">
          {props.children}
        </div>
      </article>
    </div>
  </main>
)
